import React, {useEffect} from 'react';
import * as Icon from 'ubs-icons';
import {COLOR, TIMEOUT} from "../constant";

const UToastContainer = (props) => {

    useEffect(() => {
        setTimeout(() => {
            props?.close()
        }, TIMEOUT.TOAST)
    }, [])

    return (
        <React.Fragment>
            <div className="u_c-toast u_animate u_slideInRight">
                <div className="u_c-toast-inner u_flex">
                    <div className="u_flex u_align-center">
                        <span className="u_c-toast-success-icon"><Icon.Success fill={COLOR.u_green} size={40}/></span>
                        <div className="u_c-toast-container u_px-15">
                            <h2>Successful!</h2>
                            <p className="u_mt-3">{props?.msg}</p>
                        </div>
                    </div>
                    <span className="u_c-toast-close" onClick={() => props?.close()}><Icon.Close fill={COLOR.u_blue} size={14}/></span>
                </div>
            </div>
        </React.Fragment>
    );
};

export default UToastContainer;
